import CommunityInfoRoot from './CommunityInfoRoot';

export default CommunityInfoRoot;
